import React, { useState } from "react";

import {
  Modal,
  Select,
  SelectData,
  TextField,
  ExpandablePanel,
  ExpandablePanelHeader,
  ExpandablePanelBody,
  Typography,
  Button,
} from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { InstitutionListItem, LocationProgramDataListItem } from "../../models";
import style from "./EnrollmentListCapacityTrackerModal.module.scss";

export interface EnrollmentListCapacityTrackerModalProps {
  kindergartenCapacity: InstitutionListItem[] | undefined;
  capacityTrackerModalOpen: boolean;
  handlerCloseDetails: () => void;
}
export const EnrollmentListCapacityTrackerModal = ({
  kindergartenCapacity,
  capacityTrackerModalOpen,
  handlerCloseDetails,
}: EnrollmentListCapacityTrackerModalProps) => {
  const { t } = useTranslation();

  const [selectedInstitution, setSelectedInstitution] = useState<
    InstitutionListItem | undefined
  >(
    kindergartenCapacity && kindergartenCapacity.length > 0
      ? kindergartenCapacity[0]
      : undefined
  );

  const getLocationCapacitySum = (locationId: number) => {
    let capacitySum = 0;
    selectedInstitution?.locationsAndPrograms
      .filter((x) => x.locationId === locationId)
      .forEach((program) => {
        capacitySum = capacitySum + program.locationProgramCapacity;
      });

    return capacitySum;
  };

  const getLocationCapacityOccupancySum = (locationId: number) => {
    let capacityOccupancySum = 0;
    selectedInstitution?.locationsAndPrograms
      .filter((x) => x.locationId === locationId)
      .forEach((program) => {
        capacityOccupancySum =
          capacityOccupancySum + program.locationProgramCapacityOccupancy;
      });

    return capacityOccupancySum;
  };

  const renderLocations = () => {
    let locations = [] as LocationProgramDataListItem[];
    selectedInstitution?.locationsAndPrograms?.forEach((locationAndProgram) => {
      if (
        locations.length === 0 ||
        locations.find((i) => i.locationId === locationAndProgram.locationId) ==
          null
      ) {
        locations.push(locationAndProgram);
      }
    });

    return locations?.map((location) => {
      return (
        <React.Fragment key={`location_${location.locationId}`}>
          <Row className={`${style.parentKindergartenTitle}`}>
            <Col xs={12} className={style.withoutPadding}>
              <ExpandablePanel clickableHeader>
                <ExpandablePanelHeader medium>
                  <Row className={style.withoutMargin}>
                    <Typography
                      variant="baseBold"
                      className={`${style.kindergartenTextMargin}`}
                      color={
                        getLocationCapacityOccupancySum(location.locationId) /
                          getLocationCapacitySum(location.locationId) ===
                        1
                          ? "success"
                          : "warning"
                      }
                    >
                      {`${getLocationCapacityOccupancySum(
                        location.locationId
                      )}/${getLocationCapacitySum(location.locationId)}`}
                    </Typography>
                    <Typography
                      variant="baseBold"
                      className={`${style.paddingleft} ${style.kindergartenTextMargin}`}
                    >
                      {location.locationName}
                    </Typography>
                  </Row>
                </ExpandablePanelHeader>
                <ExpandablePanelBody>
                  {renderPrograms(location.locationId)}
                </ExpandablePanelBody>
              </ExpandablePanel>
            </Col>
          </Row>
          <hr className={style.line} />
        </React.Fragment>
      );
    });
  };

  const renderPrograms = (locationId: number) => {
    return selectedInstitution?.locationsAndPrograms
      .filter((x) => x.locationId === locationId)
      .map((program) => {
        return (
          <React.Fragment key={`program_${program.locationProgramId}`}>
            <Row
              className={`${style.rowSpace} ${style.withoutMargin} ${style.kindergartenSubRow}`}
            >
              <Typography
                variant="base"
                className={`${style.kindergartenTextMargin}`}
                color={
                  program.locationProgramCapacityOccupancy /
                    program.locationProgramCapacity ===
                  1
                    ? "success"
                    : "warning"
                }
              >
                {`${program.locationProgramCapacityOccupancy}/${program.locationProgramCapacity}`}
              </Typography>

              <Typography
                variant="base"
                className={`${style.paddingleft} ${style.kindergartenTextMargin}`}
              >
                {program.locationProgramName}
              </Typography>
            </Row>
          </React.Fragment>
        );
      });
  };

  const onInstitutionChange = (e: any) => {
    const { value } = e.target;
    const instutiton = kindergartenCapacity?.find((x) => x.id === +value);
    setSelectedInstitution(instutiton!);
  };

  return (
    <Modal
      title={t("enrollmentList.capacityKindergartenFull")}
      open={capacityTrackerModalOpen}
      variant="medium"
      onClose={handlerCloseDetails}
      showCloseMark={false}
    >
      <div>
        {selectedInstitution &&
          kindergartenCapacity &&
          kindergartenCapacity.length > 0 && (
            <>
              <Row className={style.kindergartenFilter}>
                <Col xs={8}>
                  <Select
                    label={t("enrollmentList.kindergarten")}
                    name={"kindergarten"}
                    value={selectedInstitution?.id}
                    onChange={onInstitutionChange}
                    selectData={
                      {
                        valueProp: "id",
                        textProp: "name",
                        data: kindergartenCapacity ? kindergartenCapacity : [],
                      } as SelectData<InstitutionListItem>
                    }
                  />
                </Col>
                <Col xs={4}>
                  <TextField
                    type="text"
                    label={t("enrollmentList.occupancy")}
                    value={`${selectedInstitution?.capacityOccupancy}/${selectedInstitution?.capacity}`}
                    plaintext
                    color={
                      selectedInstitution?.capacityOccupancy /
                        selectedInstitution?.capacity ===
                      1
                        ? "success"
                        : "warning"
                    }
                  />
                </Col>
              </Row>
              <hr className={style.line} />
              {renderLocations()}
              <Row>
                <Col md={12}>
                  <div className={`${style.searchButtons}`}>
                    <Button
                      color="primary"
                      onClick={handlerCloseDetails}
                      className={style.modalButton}
                    >
                      {t("common.close")}
                    </Button>
                  </div>
                </Col>
              </Row>{" "}
            </>
          )}
      </div>
    </Modal>
  );
};
